import {
    UPDATE_DEVICE_START,
    UPDATE_DEVICE_SUCCESS,
    UPDATE_DEVICE_ERROR
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.devices.update, action = {type: ''}) => {
    switch (action.type) {
        case UPDATE_DEVICE_START:
            return {
                error: false,
                loading: true,
                success: false,
            };
        case UPDATE_DEVICE_SUCCESS:
            return {
                error: false,
                loading: false,
                success: true,
            };
        case UPDATE_DEVICE_ERROR:
            return {
                ...state,
                error: true,
                loading: false,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/deviceReducer/updateDeviceReducer.js